import Link from 'next/link';
import React from 'react';
import css from '../sass/sitestyle.scss';
import apiBase from '../utils/apiBase';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { authenticated: false, authChecked: false };
    this.logout = this.logout.bind(this);
  }

  async componentDidMount() {
    try {
      const response = await fetch(`${apiBase}/session`, { credentials: 'include' });
      this.setState({ authenticated: response.ok, authChecked: true });
    } catch (err) {
      this.setState({ authenticated: false, authChecked: true });
    }
  }

  async logout(event) {
    event.preventDefault();
    await fetch(`${apiBase}/logout`, {
      method: 'POST',
      credentials: 'include',
    });
    this.setState({ authenticated: false });
    window.location.assign('/');
  }

  render() {
    return (
      <header className={css.top}>
        <div className={css['nav-inner']}>
          <Link href="/">
            <a className={css.brand} aria-label="Best Burger Blog home">
              <span className={css['brand-mark']}>B</span>
              <span>Best Burger Blog</span>
            </a>
          </Link>
          <nav className={css.nav} aria-label="Main navigation">
    <Link href="/">
      <a className={css['title-row']}>Home</a>
    </Link>
    <Link
      as={'/best'}
      href={{ pathname: '/', query: { type: 'top', count: 10 } }}
    >
      <a className={css['title-row']}>Best</a>
    </Link>
    <Link
      as={'/worst'}
      href={{ pathname: '/', query: { type: 'bottom', count: 10 } }}
    >
      <a className={css['title-row']}>Worst</a>
    </Link>
    <Link href="/submit">
      <a className={css['title-row']}>Submit</a>
    </Link>
        {this.state.authChecked && this.state.authenticated ? (
          <a className={css['title-row']} href="/logout" onClick={this.logout}>
            Logout
          </a>
        ) : null}
        {this.state.authChecked && !this.state.authenticated ? (
          <Link href="/login">
            <a className={css['title-row']}>Login</a>
          </Link>
        ) : null}
          </nav>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// components/Header.js